/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Header scroll state and mobile navigation */
(function () {
    const navbar = document.getElementById('navbar');

    if (!navbar) {
        return;
    }

    const header = navbar.closest('.dn-header');
    const toggle = document.getElementById('nav-toggle');
    const homepage = document.body.classList.contains('home-template') || document.getElementById('dandelion-homepage');

    document.querySelectorAll('.dn-nav .nav a, .dn-mobile-nav .nav a').forEach(function (link) {
        link.classList.add('nav-link');
    });

    function setScrolledState() {
        navbar.classList.toggle('scrolled', !homepage || window.scrollY > 8);
    }

    function closeMobileNav() {
        if (!header || !toggle) {
            return;
        }

        header.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open navigation');
    }

    setScrolledState();
    window.addEventListener('scroll', setScrolledState, { passive: true });

    if (toggle && header) {
        toggle.addEventListener('click', function () {
            const isOpen = header.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', String(isOpen));
            toggle.setAttribute('aria-label', isOpen ? 'Close navigation' : 'Open navigation');
        });

        document.querySelectorAll('#nav-mobile a').forEach(function (link) {
            link.addEventListener('click', closeMobileNav);
        });

        window.addEventListener('resize', function () {
            if (window.innerWidth >= 768) {
                closeMobileNav();
            }
        });
    }
})();

/* Footer CTA */
(function () {
    document.querySelectorAll('.dn-site-cta-button').forEach(function (button) {
        button.addEventListener('click', function () {
            const email = document.querySelector('#dandelion-homepage input[name="email"]');

            if (email) {
                email.focus();
                email.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }

            window.location.href = 'https://joindandelion.com';
        });
    });
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
